// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"aa039b19","977":"fcccad7d"}[chunkId] + ".chunk.js";
};